import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    isTablet,
    isTabletOrWeb,
    landscapeAspectRatio,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    safeAreaView: {
        flex: 1,
        backgroundColor: COLOR.background,
    },
    gestureHandlerRootView: {
        flex: 1,
    },
    safeZone: {
        height: 16,
        width: '100%',
        backgroundColor: COLOR.background,
    },
    epgRoot: {
        overflow: 'hidden',
        backgroundColor: COLOR.background,
    },
    testLine: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: StyleSheet.hairlineWidth,
        backgroundColor: 'yellow',
    },
    popOverDatePicker: {
        width: 156,
        height: 304,
        position: 'absolute',
        left: 16,
        top: 81,
    },
    playerContainer: {
        flex: Platform.select({
            android: isTablet ? 1 : 0,
            ios: isTablet ? 1 : 0,
            web: 1,
            default: 0,
        }),
    },
    player: isTabletOrWeb
        ? { height: '100%', width: '100%' }
        : {
              width: '100%',
              aspectRatio: landscapeAspectRatio,
          },
    webEpgContainer: {
        paddingHorizontal: widthPercentageToDP(72),
    },
    noChannelsContainer: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        backgroundColor: COLOR.background,
    },
    noChannelsText: {
        lineHeight: 24,
    },
    gridSkeleton: {
        position: 'absolute',
        left: 0,
        width: '100%',
    },
    timelineSkeleton: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: COLOR.background,
    },
    emptyPageError: {
        maxWidth: widthPercentageToDP(328, 480, 480),
        textAlign: 'center',
    },
});

export default styles;
